import React from 'react';
import { Box, FormLabel } from '@mui/material';

import { familiplusAdvantageLabel, familiplusBoxAdvantageBox, familiplusIcon } from './FP-styles';

function FPAdvantage(props: {
  advantage: {
    icon: string;
    text: string;
  };
}): JSX.Element {
  return (
    <Box sx={familiplusBoxAdvantageBox}>
      <Box component="img" src={props.advantage.icon} sx={familiplusIcon}></Box>
      <FormLabel sx={familiplusAdvantageLabel}>{props.advantage.text}</FormLabel>
    </Box>
  );
}

export default FPAdvantage;
